var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("layout-gestao", {}, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12" }, [
        _c(
          "form",
          {
            attrs: {
              autocomplete: "off",
              method: "post",
              "data-vv-scope": "form",
            },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.saveItem.apply(null, arguments)
              },
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c("div", { staticClass: "row mb-3" }, [
              _c("div", { staticClass: "col-sm-auto" }, [
                _c("h1", { staticClass: "content-title" }, [
                  _vm._v(_vm._s(_vm.titleItem)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-9" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|min:3",
                            expression: "'required|min:3'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          type: "text",
                          id: "input-name",
                          name: "name",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("name") },
                          ],
                          error: _vm.fnFirstError("name"),
                        },
                        model: {
                          value: _vm.form.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.name",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.name`)) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialColorPicker",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          disabled: _vm.readonlyFormItem,
                          id: "input-color",
                          name: "color",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("color") },
                          ],
                          error: _vm.fnFirstError("color"),
                        },
                        model: {
                          value: _vm.form.color,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "color",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.color",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.color`)) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialInput",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|integer|min_value:1",
                            expression: "'required|integer|min_value:1'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          readonly: _vm.readonlyFormItem,
                          type: "number",
                          id: "input-order",
                          name: "order",
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("order") },
                          ],
                          error: _vm.fnFirstError("order"),
                          helpText: _vm.$t(`${_vm.pageID}.help.order`),
                        },
                        model: {
                          value: _vm.form.order,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "order",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.order",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.order`)) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialSelect",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          disabled: _vm.readonlyFormItem,
                          id: "input-guest",
                          name: "guest",
                          label: "name",
                          filterable: true,
                          options: _vm.lists.onoff,
                          reduce: (option) => option.code,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("guest") },
                          ],
                          error: _vm.fnFirstError("guest"),
                          helpText: _vm.$t(`${_vm.pageID}.help.guest`),
                        },
                        model: {
                          value: _vm.form.guest,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "guest",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.guest",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.guest`)) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-5" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialSelect",
                      {
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          disabled: _vm.readonlyFormItem,
                          id: "input-transform_to",
                          name: "transform_to",
                          label: "name",
                          filterable: true,
                          options: _vm.lists.transform,
                          helpText: _vm.$t(`${_vm.pageID}.help.transform_to`),
                        },
                        model: {
                          value: _vm.form.transform_to,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "transform_to",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.transform_to",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.transform_to`)) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialSelect",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          disabled: _vm.readonlyFormItem,
                          id: "input-first_process",
                          name: "first_process",
                          label: "name",
                          filterable: true,
                          options: _vm.lists.onoff,
                          reduce: (option) => option.code,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("first_process") },
                          ],
                          error: _vm.fnFirstError("first_process"),
                          helpText: _vm.$t(`${_vm.pageID}.help.first_process`),
                        },
                        model: {
                          value: _vm.form.first_process,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "first_process",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.first_process",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(
                              _vm.$t(`${_vm.pageID}.model.first_process`)
                            ) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialSelect",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          disabled: _vm.readonlyFormItem,
                          id: "input-last_process",
                          name: "last_process",
                          label: "name",
                          filterable: true,
                          options: _vm.lists.onoff,
                          reduce: (option) => option.code,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("last_process") },
                          ],
                          error: _vm.fnFirstError("last_process"),
                          helpText: _vm.$t(`${_vm.pageID}.help.last_process`),
                        },
                        model: {
                          value: _vm.form.last_process,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "last_process",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.last_process",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.last_process`)) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "MaterialSelect",
                      {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'",
                          },
                        ],
                        staticClass: "city-form-group city-bg",
                        attrs: {
                          disabled: _vm.readonlyFormItem,
                          id: "input-report_to",
                          name: "report_to",
                          label: "name",
                          filterable: true,
                          options: _vm.lists.onoff,
                          reduce: (option) => option.code,
                          inputClasses: [
                            { "is-invalid": _vm.fnHasError("report_to") },
                          ],
                          error: _vm.fnFirstError("report_to"),
                          helpText: _vm.$t(`${_vm.pageID}.help.report_to`),
                        },
                        model: {
                          value: _vm.form.report_to,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "report_to",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.report_to",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.$t(`${_vm.pageID}.model.report_to`)) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("buttons-footer", {
              attrs: {
                enableButtons: !_vm.readonlyFormItem,
                cancelTitle: _vm.cancelTitle,
                submitTitle: _vm.submitTitle,
              },
              on: {
                save: _vm.saveItem,
                cancel: function ($event) {
                  return _vm.handleBack(`${_vm.moduleCode}.${_vm.pageID}`)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }